/**
 * Netx core
 * @module core
 */
import {getPrefixedLogger} from '@netx/core-next/instance/logger';

const logger = getPrefixedLogger('core');

const loadInitialData = async () => {};

export default {
	namespace: 'netx',
	initialize() {
		logger.debug('setting up module...');

		// Start history
		Backbone.history.start({silent: true});

		// "bunldes" that do not depend on the full "core-app"
		if (
			window.location.hash.match(
				/share\/request\/((?!review|approve|reject).)*$/,
			)
		) {
			logger.debug('sending to share landing module...');
			return new Promise((resolve, reject) => {
				loadInitialData().then(() => {
					import(
						/* webpackChunkName: "core-share-link-landing" */ '@netx/core-share-link-landing'
					).then((ShareLinkLanding) => {
						logger.silly('loading share landing module...');
						dispatcher.trigger('netx:load:module', ShareLinkLanding.default, {
							loadUrl: true,
							error: reject,
							initialized: (args) => {
								logger.silly('initialized share landing module');
								resolve(args);
							},
						});
					});
				});
			});
		}

		if (window.location.hash.match(/uploads\/request\/(.)*$/)) {
			logger.debug('sending to core-upload-asset-request module...');
			return new Promise((resolve, reject) => {
				loadInitialData().then(() => {
					import(
						/* webpackChunkName: "core-upload-asset-request" */ '@netx/core-upload-asset-request'
					).then((UploadAssetRequest) => {
						logger.silly('loading core-upload-asset-request module...');
						dispatcher.trigger('netx:load:module', UploadAssetRequest.default, {
							loadUrl: true,
							error: reject,
							initialized: (args) => {
								logger.silly('initialized core-upload-asset-request module');
								resolve(args);
							},
						});
					});
				});
			});
		}

		return new Promise((resolve, reject) => {
			loadInitialData().then(() => {
				logger.debug('initializing module...');
				// Bring in custom controller
				import(
					/* webpackChunkName: "core-module-dependencies" */ '@netx/core/controller'
				);
				import(
					/* webpackChunkName: "core-module-dependencies" */ '@netx/core-app'
				).then((App) => {
					// Initialize app
					dispatcher.trigger('netx:load:module', App.default, {
						error: reject,
						initialized: (args) => {
							logger.silly('initialized module');
							resolve(args);
						},
					});
				});
			});
		});
	},
};
